function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BrazilFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4932",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18,
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4630)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#009933"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_4630",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_4630)",
      children: [/*#__PURE__*/_jsxs("g", {
        filter: "url(#filter0_d_621_4630)",
        children: [/*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9451 5.77803L21.0965 12.1556L11.8206 18.1285L2.8567 12.032L11.9451 5.77803Z",
          fill: "#FFD221"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9451 5.77803L21.0965 12.1556L11.8206 18.1285L2.8567 12.032L11.9451 5.77803Z",
          fill: "url(#paint0_linear_621_4630)"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 15.9C14.0711 15.9 15.75 14.2211 15.75 12.15C15.75 10.0789 14.0711 8.40001 12 8.40001C9.92893 8.40001 8.25 10.0789 8.25 12.15C8.25 14.2211 9.92893 15.9 12 15.9Z",
        fill: "#2E42A5"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_4630",
        style: {
          maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "8",
        y: "8",
        width: "8",
        height: "8",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 15.9C14.0711 15.9 15.75 14.2211 15.75 12.15C15.75 10.0789 14.0711 8.40001 12 8.40001C9.92893 8.40001 8.25 10.0789 8.25 12.15C8.25 14.2211 9.92893 15.9 12 15.9Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_4630)",
        children: [/*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.785 13.9275L10.6175 14.0156L10.6495 13.829L10.5139 13.6969L10.7012 13.6697L10.785 13.5L10.8688 13.6697L11.0561 13.6969L10.9205 13.829L10.9525 14.0156L10.785 13.9275Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.285 13.9275L12.1175 14.0156L12.1495 13.829L12.0139 13.6969L12.2012 13.6697L12.285 13.5L12.3688 13.6697L12.5561 13.6969L12.4205 13.829L12.4525 14.0156L12.285 13.9275Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.285 14.8275L12.1175 14.9156L12.1495 14.729L12.0139 14.5969L12.2012 14.5697L12.285 14.4L12.3688 14.5697L12.5561 14.5969L12.4205 14.729L12.4525 14.9156L12.285 14.8275Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.535 11.6775L11.3675 11.7656L11.3995 11.579L11.2639 11.4469L11.4512 11.4197L11.535 11.25L11.6188 11.4197L11.8061 11.4469L11.6705 11.579L11.7025 11.7656L11.535 11.6775Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.535 13.1775L11.3675 13.2656L11.3995 13.079L11.2639 12.9469L11.4512 12.9197L11.535 12.75L11.6188 12.9197L11.8061 12.9469L11.6705 13.079L11.7025 13.2656L11.535 13.1775Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.485 12.4275L10.3174 12.5156L10.3494 12.329L10.2139 12.1969L10.4012 12.1697L10.485 12L10.5687 12.1697L10.756 12.1969L10.6205 12.329L10.6525 12.5156L10.485 12.4275Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.43496 13.0275L9.26744 13.1156L9.29944 12.929L9.16391 12.7969L9.3512 12.7697L9.43496 12.6L9.51872 12.7697L9.70601 12.7969L9.57049 12.929L9.60248 13.1156L9.43496 13.0275Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.885 10.4775L12.7175 10.5656L12.7495 10.379L12.614 10.2469L12.8013 10.2197L12.885 10.05L12.9688 10.2197L13.1561 10.2469L13.0206 10.379L13.0526 10.5656L12.885 10.4775Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M7.4436 11.2479L7.55639 9.75212C11.1548 10.0235 13.995 11.2066 16.0412 13.3113L14.9657 14.3569C13.1922 12.5327 10.6968 11.4932 7.4436 11.2479Z",
          fill: "#F7FCFF"
        })]
      })]
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("filter", {
      id: "filter0_d_621_4630",
      x: "2.85669",
      y: "5.77803",
      width: "18.2398",
      height: "12.3504",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {}), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0313726 0 0 0 0 0.368627 0 0 0 0 0 0 0 0 0.28 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_621_4630"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_621_4630",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_621_4630",
      x1: "24",
      y1: "21",
      x2: "24",
      y2: "3",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#FFC600"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#FFDE42"
      })]
    })]
  })]
}));
//# sourceMappingURL=Brazil.js.map